import React, { useState, useEffect, useRef, useMemo } from 'react';
import { FormInputWrapper } from '../../styles/common-styles'
import { InputLabel, TextField, FormHelperText, TextareaAutosize, Tooltip } from '@material-ui/core';
import BusinessIcon from '@mui/icons-material/Business';
import GenericModal from '../Modal/GenericModal';
import { useTranslation } from 'react-i18next';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import Popper from '@mui/material/Popper';
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import { phoneInputMask, phoneMaskingPatternWise, phoneKeyInputMask } from '../../helper/formatePhone';
import { formatSSNVisibility } from '../../helper/formatSSN';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * @param {{
 * label: string,
 * labelId: string,
 * formikValue: Object,
 * formikChange: Function,
 * isDoubled?: Boolean,
 * disabled:boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean
 * maxlength: String
 * maxValue: Number
 * onlyNumeric: Boolean
 * onlyAlphanumeric:Boolean
 * customStyle: css
 * }} props
 */
// for type number AND maxlength, need
//  * maxValue: Number
//  * onlyNumeric: Boolean

export const TextInput = (props) => {
    const [formInvalidAlerts, setFormInvalidAlerts] = useState({ errShow: false, errMessage: '' });
    const { t } = useTranslation();
    const { errMsgCustom, onlyAlphabetFirst,onlyDigits,onlyNumberDigits, formik, customStyle, label, labelId, formikValue, formikChange, disabled, isDoubled, isCustomised, errors, helperText, mandatory, maxValue, minValue, maxlength, onBlur, touched, onlyNumeric, type, onlyAlphanumeric, errMsg, hoverText, adornment, placeholder, phoneFormat = false, maskPattern, ssnMask, ssnSymbolicPattern, onTooltip, textAlign, hidden, title, onKeyDown  } = props;
    // const isHidden = hide=='hide' ? false : true;,
    let maxValues = (maxValue) ? maxValue : 2147483647;
    let minValues = (minValue) ? minValue : -2147483647;
    const [onHoverText, setHoverText] = useState('');
    const [filled, setFilled] = useState('');
    useEffect(() => {
        if (formikValue) {
            setFilled('filled')
        }
        else{
            setFilled('')
        }
    }, [formikValue])

    return (
        <FormInputWrapper style={{...customStyle, display: hidden ? 'none' : 'block'}} isDoubled={isDoubled ? isDoubled : null} isCustomised={isCustomised ? isCustomised : null} className={isDoubled ? 'doubled' : null}>
            <InputLabel htmlFor={labelId}>{label ? label : <>&nbsp;</>}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            <Tooltip title={onTooltip ? onTooltip : ""} arrow >
                <TextField

                    className={filled}
                    data-testid={'search-text-field'}
                    disabled={disabled}
                    error={(errors && touched) ? true : false}
                    id={labelId}
                    name={labelId}
                    type={type ? type : 'text'}
                    variant="outlined"
                    onKeyDown={onKeyDown}
                    onChange={
                        (event) => {
                            if (phoneFormat) {
                                let value = phoneInputMask(event.target.value, maskPattern);
                                event.target.value = value;
                                return formikChange(event)
                            }
                            if (ssnMask) {
                                let value = formatSSNVisibility(event.target.value, ssnSymbolicPattern);
                                event.target.value = value;

                                return formikChange(event)
                            }
                            if (onlyNumeric) {
                                if (event.target.value.match(/^-?\d*\.?\d*$/)) {
                                    if ((parseFloat(event.target.value) <= minValues)) {
                                        setFormInvalidAlerts({
                                            errShow: true, errMessage: `${errMsgCustom ? errMsgCustom :
                                                errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')}
                                    ${(errMsgCustom) ? '' : (maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}`
                                        });
                                        return formikChange(-1);
                                    }
                                    // Error handlers: Numeric range
                                    if ((parseFloat(event.target.value) >= 0) && (parseFloat(event.target.value) > maxValues)) {
                                        setFormInvalidAlerts({
                                            errShow: true, errMessage: `${errMsgCustom ? errMsgCustom :
                                                errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')}
                                    ${(errMsgCustom) ? '' : (maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}`
                                        });
                                        return formikChange(-1);
                                    }
                                    return formikChange(event);
                                }
                            } else if (onlyAlphanumeric) {
                                if (event.target.value == "") return formikChange(event);
                                if (event.target.value.match(/^\w+$/)) {
                                    return formikChange(event);
                                }
                            } else if (onlyAlphabetFirst) {
                                if (event.target.value == "") return formikChange(event);
                                if (event.target.value.charAt(0).match(/^[a-zA-Z]+$/)) {
                                    return formikChange(event);
                                }

                            }
                            else if (onlyDigits) {
                                if (event.target.value == "") return formikChange(event);
                                if (event.target.value.charAt(0).match(/^\d+$/)) {
                                    return formikChange(event);
                                }
                                event.target.value ="";
                                return formikChange(event);
                            }
                            else if (onlyNumberDigits) {
                                if (event.target.value == "") return formikChange(event);
                                if (event.target.value.match(/^\d+$/)) {
                                    return formikChange(event);
                                }
                                event.target.value ="";
                                return formikChange(event);
                            }
                            else return formikChange(event);
                        }
                    }
                    onKeyPress={(event) => {
                        if (phoneFormat) {
                            let value = phoneInputMask(event.target.value, maskPattern);
                            event.target.value = value;
                            return formikChange(event)
                        }
                    }}
                    onMouseOver={(e) => { hoverText && setHoverText(hoverText) }} onMouseOut={(e) => { hoverText && setHoverText('') }}
                    onBlur={(e) => {
                        let value = e.target.value;
                        if (value) {
                            setFilled('filled')
                        } else {
                            setFilled('')
                        }
                        onBlur && onBlur(e);
                    }}
                    value={formikValue}
                    inputProps={{
                        maxLength: maxlength ? maxlength : '100',
                        max: 10, autoComplete: 'off',
                        "aria-required": mandatory ? true : null,
                        style: { textAlign: textAlign ? "right" : "" },
                        ...(title ? { title } : {})
                    }}
                    InputProps={adornment ? adornment : ""}
                    placeholder={placeholder ? placeholder : ''}
                    autoComplete={"false"}
                />
            </Tooltip>
            {formInvalidAlerts['errShow'] &&
                <GenericModal
                    open={formInvalidAlerts['errShow']}
                    onClose={() => setFormInvalidAlerts({ errShow: false, errMessage: '' })}
                    error={formInvalidAlerts}
                    buttonText='Ok'
                    onButtonPress={() => (formik) ? formik.setFieldValue(labelId, 0) : ""}
                />}
            {(helperText) ?
                errors && helperText && <FormHelperText className="helperText">{helperText}</FormHelperText> :
                errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            {onHoverText && <FormHelperText className="hoverTextAccess">{onHoverText}</FormHelperText>}
        </FormInputWrapper>
    )
}

/**
 * @param {{
 * label: string,
 * labelId: string,
 * formikValue: Object,
 * formikChange: Function,
 * isDoubled?: Boolean,
 * disabled:boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean
 * maxlength: String
 * maxValue: Number
 * onlyNumeric: Boolean
 * onlyAlphanumeric:Boolean
 * customStyle: css
 * handlelookUp: Function
 * iconHide: Boolean,
 * isIconDisabled: Boolean
 * }} props
 */
// for type number AND maxlength, need
//  * maxValue: Number
//  * onlyNumeric: Boolean

export const TextEditableLookupInput = (props) => {
    const [formInvalidAlerts, setFormInvalidAlerts] = useState({ errShow: false, errMessage: '' });
    const { t } = useTranslation();
    const { onlyAlphabetFirst, formik, customStyle, label, labelId, formikValue, formikChange, disabled, isDoubled, errors, helperText, mandatory, maxValue, minValue, maxlength, onBlur, touched, onlyNumeric, type, onlyAlphanumeric, errMsg, hoverText, adornment, placeholder, iconHide, isIconDisabled, handlelookUp, customIconStyle, title } = props;
    // const isHidden = hide=='hide' ? false : true;
    let maxValues = (maxValue) ? maxValue : 2147483647;
    let minValues = (minValue) ? minValue : -2147483647;
    const [onHoverText, setHoverText] = useState('');
    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} className={isDoubled ? 'icon-text doubled' : 'icon-text'}>
            <InputLabel htmlFor={labelId}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            <TextField
                disabled={disabled}
                error={(errors && touched) ? true : false}
                id={labelId}
                name={labelId}
                type={type ? type : 'text'}
                variant="outlined"
                onChange={
                    (event) => {
                        if (onlyNumeric) {
                            if (event.target.value.match(/^-?\d*\.?\d*$/)) {
                                if ((parseFloat(event.target.value) <= minValues)) {
                                    setFormInvalidAlerts({ errShow: true, errMessage: `${errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')}  ${(maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}` });
                                    return formikChange(-1);
                                }
                                // Error handlers: Numeric range
                                if ((parseFloat(event.target.value) >= 0) && (parseFloat(event.target.value) > maxValues)) {
                                    setFormInvalidAlerts({ errShow: true, errMessage: `${errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')} ${(maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}` });
                                    return formikChange(-1);
                                }
                                return formikChange(event);
                            }
                        } else if (onlyAlphanumeric) {
                            if (event.target.value == "") return formikChange(event);
                            if (event.target.value.match(/^\w+$/)) {
                                return formikChange(event);
                            }
                        } else if (onlyAlphabetFirst) {
                            if (event.target.value == "") return formikChange(event);
                            if (event.target.value.charAt(0).match(/^[a-zA-Z]+$/)) {
                                return formikChange(event);
                            }
                        } else return formikChange(event);
                    }
                }
                onKeyPress={(event) => {
                }}
                onMouseOver={(e) => { hoverText && setHoverText(hoverText) }} onMouseOut={(e) => { hoverText && setHoverText('') }}
                onBlur={onBlur}
                value={formikValue}
                inputProps={{
                    maxLength: maxlength ? maxlength : '100',
                    max: 10, autoComplete: 'off',
                    ...(title ? { title } : {})
                }}
                InputProps={adornment ? adornment : ""}
                placeholder={placeholder ? placeholder : ''}
            />
            {(!iconHide) ? <BusinessIcon style={customIconStyle} className={isIconDisabled ? 'icon-disabled' : ''} onClick={() => handlelookUp()} data-label={labelId} /> : null}

            {formInvalidAlerts['errShow'] &&
                <GenericModal
                    open={formInvalidAlerts['errShow']}
                    onClose={() => setFormInvalidAlerts({ errShow: false, errMessage: '' })}
                    error={formInvalidAlerts}
                    buttonText='Ok'
                    onButtonPress={() => (formik) ? formik.setFieldValue(labelId, 0) : ""}
                />}
            {(helperText) ?
                errors && helperText && <FormHelperText className="helperText">{helperText}</FormHelperText> :
                errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            {onHoverText && <FormHelperText className="asterisk">{onHoverText}</FormHelperText>}
        </FormInputWrapper>
    )
}

/**
 * @param {{
 * label: string,
 * labelId: string,
 * formikValue: Object,
 * handlelookUp: Function,
 * isDoubled?: Boolean,
 * disabled: Boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * iconHide: Boolean,
 * formik: Function
 * isIconDisabled: Boolean
 * }} props
 */
export const TextLookUpInput = (props) => {
    const { customStyle, label, labelId, formikValue, isDoubled, handlelookUp, disabled, errors, touched, mandatory, iconHide, formik, isIconDisabled, formikCustomChange, title } = props;
    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} className={isDoubled ? 'icon-text doubled' : 'icon-text'}>
            <InputLabel htmlFor={labelId}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            <TextField error={(errors && touched) ? true : false} disabled={disabled} id={labelId} name={labelId} type="text" variant="outlined" value={formikValue} onChange={formikCustomChange ?? ((formik) && formik.handleChange)} inputProps={{ ...(title ? { title } : {}) }}/>

            {(!iconHide) ? <BusinessIcon className={isIconDisabled ? 'icon-disabled' : ''} onClick={() => handlelookUp()} data-label={labelId} /> : null}
            {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
        </FormInputWrapper>
    )
}

export const TextAreaInput = (props) => {
    const { customStyle, label, labelId, formikValue, isDoubled, disabled, errors, touched, mandatory, formik, formikChange, maxRows, minRows, placeholder, maxlength, onTooltip, textAreaHeight, title } = props;
    const showMUITooltip = Boolean(onTooltip && onTooltip.trim() && !title);
    const textarea =
        <TextareaAutosize
            id={labelId}
            className={(errors && touched) ? 'error-txtarea' : ''}
            aria-label="minimum height"
            maxRows={maxRows ? maxRows : 10}
            minRows={minRows ? minRows : 3}
            rowsMax={maxRows ? maxRows : 10}
            rowsMin={minRows ? minRows : 3}
            maxLength={maxlength ? maxlength : ''}
            name={labelId}
            onChange={formikChange}
            value={formikValue}
            disabled={disabled}
            placeholder={placeholder ? placeholder : ''}
            title={title}
            style={{ width: '100%', padding: '16px', boxSizing: 'border-box', height: textAreaHeight ? textAreaHeight : 'auto', overflow: 'auto' }}
        />;

    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} className={isDoubled ? 'icon-text doubled' : 'icon-text'}>
            <InputLabel htmlFor={labelId}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            {showMUITooltip
                ? <Tooltip title={onTooltip} arrow disableHoverListener={!showMUITooltip} disableFocusListener={!showMUITooltip} disableTouchListener={!showMUITooltip}>{textarea}</Tooltip>
                : textarea
            }
            {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
        </FormInputWrapper>
    )
}

export const TextAreaLookupInput = (props) => {
    const { customStyle, label, labelId, formikValue, isDoubled, handlelookUp, disabled, errors, touched, mandatory, iconHide, formik, formikChange, isIconDisabled, title } = props;
    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} className={isDoubled ? 'icon-text doubled' : 'icon-text'}>
            <InputLabel htmlFor={labelId}>{label}</InputLabel>
            <TextareaAutosize
                aria-label="minimum height"
                maxRows={10}
                minRows={3}
                name={labelId}
                onChange={formikChange}
                value={formikValue}
                disabled={disabled}
                title={title}
                style={{ width: '95%', padding: '16px', boxSizing: 'border-box', height: 'auto', overflow: 'auto' }}
            />
            {(!iconHide) ? <BusinessIcon className={isIconDisabled ? 'icon-disabled' : ''} style={{ position: 'absolute' }} onClick={() => handlelookUp()} data-label={labelId} /> : null}
            {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
        </FormInputWrapper>
    )
}

export const TextAutoInputLookup = (props) => {
    const { t } = useTranslation();
    let inputElement = useRef();
    const { onCustomChange, label, labelId, formik, DropdownData, mandatory, errors, touched, isDoubled, disabled, customStyle, iconHide, isTripple, isIconDisabled, handlelookUp, title } = props;
    const [optionTList, setOptionTList] = React.useState([]);
    const [labelValue, setLabelValue] = useState('');
    const [isAlert, setAlert] = useState(false);
    const [termName, setTermName] = useState(null);
    let inputRef;
    const getTOptions = () => {
        let options = [];
        for (let key in DropdownData) {
            options.push({ id: DropdownData[key].uniqueId, label: DropdownData[key].displayText })
        }
        return options;
    }
    useEffect(() => {
        setOptionTList(getTOptions());
    }, [DropdownData])

    const handleButtonPress = () => {
        setAlert(false);
        inputRef.focus();
    }

    useEffect(() => {
        if (DropdownData.length > 0) {
            const displayText = DropdownData.filter(value => value.uniqueId == formik.values[labelId])[0]?.displayText;
            displayText ? setLabelValue(displayText) : setLabelValue("");
        }
    }, [formik.values[labelId], DropdownData])
    return (
        <>
            {isAlert &&
                <GenericModal title={t('commonLabel.transdocNotFoundAlert', { what: termName })}
                    open={isAlert} onClose={setAlert}
                    onButtonPress={handleButtonPress}
                    buttonText={t('buttonLabel.ok')}
                />
            }
            <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} isTripple={isTripple ? isTripple : null} className={isDoubled ? 'icon-text doubled' : 'icon-text'}>
                <InputLabel htmlFor="labelValue">{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                <Autocomplete
                    freeSolo
                    id="labelValue"
                    disableClearable
                    options={optionTList}
                    openOnFocus
                    onChange={(event, newValue) => {
                        formik.setFieldValue(labelId, newValue.id)
                        onCustomChange && onCustomChange(event, newValue.id);
                    }}
                    onBlur={(event) => {
                        let isExist = DropdownData.find(etd => etd.displayText === event.target.value)
                        if (!isExist || isExist?.uniqueId === 0 || isExist?.uniqueId === "0") {

                            if (event.target.value !== "") {
                                setTermName(event.target.value);
                                setAlert(true);
                            }
                            formik.setFieldValue(labelId, 0)
                            setLabelValue('');

                        }

                        else {
                            const filteredArray = DropdownData.filter(value => value.displayText == event.target.value);
                            formik.setFieldValue(labelId, filteredArray[0].uniqueId)
                            setLabelValue(event.target.value);
                            //setAlert(false);
                        }
                    }}
                    inputValue={labelValue}
                    disabled={disabled}
                    onInputChange={(event, newInputValue) => {
                        setLabelValue(newInputValue);
                    }}
                    renderOption={(props, option) => {
                        return (
                            <li {...props} key={option.id}>
                                {option.label}
                            </li>
                        );
                    }}
                    renderInput={(params) =>
                        <>
                            <TextField {...params}
                                error={errors && touched ? true : false}
                                disabled={disabled}
                                name={labelId}
                                inputRef={input => {
                                    inputRef = input;
                                }}
                                inputProps={{ ...(params.inputProps || {}), ...(title ? { title } : {}) }}
                                variant="outlined" InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (!iconHide) && <InputAdornment position="start"><span style={{ cursor: 'pointer', color: '#0000008a' }} className="material-icons-outlined">
                                        info
                                    </span></InputAdornment>
                                }} />
                            <BusinessIcon className={isIconDisabled ? 'icon-disabled' : ''} style={{ position: 'absolute' }} onClick={handlelookUp} data-label={labelId} />
                        </>
                    }

                />

                {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            </FormInputWrapper>
        </>

    )
}

export const TextAutoInput = (props) => {
    const { t } = useTranslation();
    let inputElement = useRef();
    const {
        onCustomChange, label, labelId, formik, DropdownData, mandatory, errors, touched, isDoubled, disabled, customStyle, iconHide, isTripple, title, searchByWeightage,
        allowZeroId = false,
        allowUnlisted = false        
    } = props;
    const [optionTList, setOptionTList] = React.useState([]);
    const [labelValue, setLabelValue] = useState('');
    const [isAlert, setAlert] = useState(false);
    const [termName, setTermName] = useState(null);
    const [isTyping, setIsTyping] = useState(false);
    let inputRef;
    const getTOptions = ( array = DropdownData) => {
        let options = [];
        for (let key in array) {
            options.push({ id: array[key].uniqueId, label: array[key].displayText })
        }
        return options;
    }
    useEffect(() => {
        setOptionTList(getTOptions());
    }, [DropdownData])

    const handleSearch = () => {
        const term = labelValue.trim().toLowerCase();
         const weightedResults = DropdownData
        .map(item => {
        const label = (item.displayText || '').toLowerCase();

        if (label === term) {
            return { item, weight: 0 };
        } else if (label.startsWith(term)) {
            return { item, weight: 1 };
        } else if (label.includes(term)) {
            return { item, weight: 2 };
        } else {
            return null;
        }
        })
        .filter(Boolean)
        .sort((a, b) => a.weight - b.weight)
        .map(({ item }) => item);
    return getTOptions(weightedResults);
    }
    const handleButtonPress = () => {
        setAlert(false);
        inputRef.focus();
    }

    useEffect(() => {
        if(searchByWeightage){
            if(!labelValue || labelValue === '' || !isTyping ) {
                setOptionTList(getTOptions());
            }else{
                setOptionTList(handleSearch());
            }}
    },[labelValue, isTyping])
    useEffect(() => {
        if (DropdownData.length > 0) {
            const displayText = DropdownData.filter(value => value.uniqueId == formik.values[labelId])[0]?.displayText;
            displayText ? setLabelValue(displayText) : setLabelValue("");
        }
    }, [formik.values[labelId], DropdownData])
    return (
        <>
            {isAlert &&
                <GenericModal 
                    title={t('commonLabel.termNotFoundAlert', { 
                        what: termName, 
                        label: label || 'option'
                    })}
                    open={isAlert} onClose={setAlert}
                    onButtonPress={handleButtonPress}
                    buttonText={t('buttonLabel.ok')}
                />
            }

            <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} isTripple={isTripple ? isTripple : null} className={isDoubled ? 'doubled' : ''}>
                <InputLabel htmlFor="labelValue">{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
                <Autocomplete
                    freeSolo
                    id="labelValue"
                    disableClearable
                    options={optionTList}
                    openOnFocus
                    onChange={(event, newValue) => {
                        formik.setFieldValue(labelId, newValue.id)
                        setIsTyping(false);
                        onCustomChange && onCustomChange(event, newValue.id);
                    }}
                    onBlur={(event) => {
                        let isExist = DropdownData.find(etd => etd.displayText === event.target.value)
                        if (!isExist || isExist?.uniqueId === 0 || isExist?.uniqueId === "0") {

                            if (event.target.value !== "") {
                                setTermName(event.target.value);
                                setAlert(true);
                            }
                            formik.setFieldValue(labelId, 0)
                            setLabelValue('');

                        }

                        else {
                            const filteredArray = DropdownData.filter(value => value.displayText == event.target.value);
                            formik.setFieldValue(labelId, filteredArray[0].uniqueId)
                            setLabelValue(event.target.value);
                            //setAlert(false);
                        }
                    }}
                    inputValue={labelValue}
                    disabled={disabled}
                    onInputChange={(event, newInputValue) => {
                        setLabelValue(newInputValue);
                        setIsTyping(true);
                    }}
                    renderOption={(props, option) => {
                        return (
                            <li {...props} key={option.id}>
                                {option.label}
                            </li>
                        );
                    }}
                    renderInput={(params) =>
                        <TextField {...params}
                            error={errors && touched ? true : false}
                            disabled={disabled}
                            name={labelId}
                            inputRef={input => {
                                inputRef = input;
                            }}
                            inputProps={{ ...(params.inputProps || {}), ...(title ? { title } : {}) }}
                            variant="outlined" InputProps={{
                                ...params.InputProps,
                                endAdornment: (!iconHide) && <InputAdornment position="start"><span style={{ cursor: 'pointer', color: '#0000008a' }} className="material-icons-outlined">
                                    info
                                </span></InputAdornment>
                            }} />}
                />
                {errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            </FormInputWrapper>
        </>

    )
}

export const TextPasswordInput = (props) => {
    const [formInvalidAlerts, setFormInvalidAlerts] = useState({ errShow: false, errMessage: '' });
    const { t } = useTranslation();
    const { onlyAlphabetFirst, formik, customStyle, label, labelId, formikValue, formikChange, disabled, isDoubled, errors, helperText, mandatory, maxValue, minValue, maxlength, onBlur, touched, onlyNumeric, type, onlyAlphanumeric, errMsg, hoverText, adornment, placeholder, title } = props;
    // const isHidden = hide=='hide' ? false : true;
    let maxValues = (maxValue) ? maxValue : 2147483647;
    let minValues = (minValue) ? minValue : -2147483647;
    const [onHoverText, setHoverText] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }

    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled ? isDoubled : null} className={isDoubled ? 'doubled' : null}>
            <InputLabel htmlFor={labelId}>{label}<span className={(mandatory) ? 'asterisk' : ''}>{(mandatory) ? '*' : ''}</span></InputLabel>
            <TextField
                disabled={disabled}
                error={(errors && touched) ? true : false}
                id={labelId}
                name={labelId}
                type={showPassword ? "text" : "password"}
                variant="outlined"
                onChange={
                    (event) => {
                        if (onlyNumeric) {
                            if (event.target.value.match(/^-?\d*\.?\d*$/)) {
                                if ((parseFloat(event.target.value) <= minValues)) {
                                    setFormInvalidAlerts({ errShow: true, errMessage: `${errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')}  ${(maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}` });
                                    return formikChange(-1);
                                }
                                // Error handlers: Numeric range
                                if ((parseFloat(event.target.value) >= 0) && (parseFloat(event.target.value) > maxValues)) {
                                    setFormInvalidAlerts({ errShow: true, errMessage: `${errMsg ? errMsg : t('popupMessages.Numberoutsideofallowedrange')} ${(maxValue) ? `${(minValue) ? minValue : 0} - ${maxValue}` : `-2147483648 to +2147483647`}` });
                                    return formikChange(-1);
                                }
                                return formikChange(event);
                            }
                        } else if (onlyAlphanumeric) {
                            if (event.target.value == "") return formikChange(event);
                            if (event.target.value.match(/^\w+$/)) {
                                return formikChange(event);
                            }
                        } else if (onlyAlphabetFirst) {
                            if (event.target.value == "") return formikChange(event);
                            if (event.target.value.charAt(0).match(/^[a-zA-Z]+$/)) {
                                return formikChange(event);
                            }
                        } else return formikChange(event);
                    }
                }
                onKeyPress={(event) => {
                }}
                onMouseOver={(e) => { hoverText && setHoverText(hoverText) }} onMouseOut={(e) => { hoverText && setHoverText('') }}
                onBlur={onBlur}
                value={formikValue}
                inputProps={{
                    maxLength: maxlength ? maxlength : '100',
                    max: 10, autoComplete: 'off',
                    ...(title ? { title } : {}),
                }}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                            style={{ padding: '9px' }}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>,
                }}
                placeholder={placeholder ? placeholder : ''}
            />
            {formInvalidAlerts['errShow'] &&
                <GenericModal
                    open={formInvalidAlerts['errShow']}
                    onClose={() => setFormInvalidAlerts({ errShow: false, errMessage: '' })}
                    error={formInvalidAlerts}
                    buttonText='Ok'
                    onButtonPress={() => (formik) ? formik.setFieldValue(labelId, 0) : ""}
                />}
            {(helperText) ?
                errors && helperText && <FormHelperText className="helperText">{helperText}</FormHelperText> :
                errors && touched && <FormHelperText className="helperText">{errors}</FormHelperText>}
            {onHoverText && <FormHelperText className="asterisk">{onHoverText}</FormHelperText>}
        </FormInputWrapper>
    )
}

/**
 * @param {{
 * label: string,
 * labelId: string,
 * formikValue: any,
 * formikChange: Function,
 * isDoubled?: Boolean,
 * disabled?: boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory: Boolean,
 * dropdownData: Object '{optionLists,key,value}',
 * customStyle?: object,
 * sortAsc?: boolean,
 * onTooltip?: string,
 * placeholder?: string,
 * loading?: boolean,
 * noOptionsText?: string
 * disableClearable?: boolean
 * }} props
 */
export const TextAutoInputWithDropDown = (props) => {
    const { t } = useTranslation();
    const {
        label,
        labelId,
        formikValue,
        formikChange,
        isDoubled = false,
        disabled = false,
        errors,
        touched,
        mandatory = false,
        dropdownData,
        customStyle = {},
        sortAsc = false,
        onTooltip,
        placeholder,
        loading = false,
        noOptionsText,
        disableClearable = false
    } = props;

    const [options, setOptions] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    // Helper function to determine appropriate empty value based on data types
    const getEmptyValue = () => {
        if (!dropdownData?.optionLists?.length) return '';

        // Look for an explicit empty option - only consider it empty if BOTH uniqueId and displayText suggest emptiness
        // This is needed for fields like Campus where 0 record is actually a valid record.
        const emptyOption = dropdownData.optionLists.find(item =>
            (item.uniqueId === "" && (item.displayText === "" || !item.displayText)) ||
            (item.uniqueId === 0 && (item.displayText === "" || !item.displayText)) ||
            (item.uniqueId === "0" && (item.displayText === "" || !item.displayText)) ||
            (item.uniqueId === null || item.uniqueId === undefined)
        );

        if (emptyOption) {
            return emptyOption.uniqueId;
        }

        const allOptions = dropdownData.optionLists;

        // Check if we have string-based uniqueIDs (excluding empty ones)
        const hasStringIds = allOptions.some(item =>
            item.uniqueId !== "" &&
            item.uniqueId !== 0 &&
            item.uniqueId !== null &&
            item.uniqueId !== undefined &&
            typeof item.uniqueId === 'string' &&
            isNaN(Number(item.uniqueId))
        );

        // If we have string-based IDs, return empty string
        // If we have only numeric IDs and no empty option, return null to avoid conflicts
        return hasStringIds ? '' : null;
    };

    // Process dropdown data to create options array
    useEffect(() => {
        if (dropdownData?.optionLists?.length > 0) {
            let processedOptions = dropdownData.optionLists.map((item) => {
                return {
                    value: item.uniqueId !== undefined ? item.uniqueId : item[dropdownData.value],
                    label: item[dropdownData.key] || item.displayText,
                    uniqueId: item.uniqueId,
                    ...item
                };
            });

            // Separate empty options from valid options
            // Empty options (uniqueId: 0 with empty displayText) should always be at the top
            const emptyOptions = processedOptions.filter(opt =>
                (opt.uniqueId === 0 || opt.uniqueId === "0") &&
                (!opt.displayText || opt.displayText === "")
            );

            const nonEmptyOptions = processedOptions.filter(opt =>
                !((opt.uniqueId === 0 || opt.uniqueId === "0") &&
                  (!opt.displayText || opt.displayText === ""))
            );

            // Sort by option label if the api data is not sorted already just pass this prop
            // We have this issue in a couple places around the app.
            // Only sort non-empty options to keep empty options at the top
            if (sortAsc) {
                nonEmptyOptions.sort((a, b) => {
                    const labelA = a.label || '';
                    const labelB = b.label || '';
                    return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
                });
            }
            
            processedOptions = [...emptyOptions, ...nonEmptyOptions];

            setOptions(processedOptions);
        } else {
            setOptions([]);
        }
    }, [dropdownData, sortAsc]);

    // Find selected option based on formik value
    const selectedOption = useMemo(() => {
        if ((formikValue === null || formikValue === undefined) || !options.length || !dropdownData?.value) return null;

        const found = options.find(option => {
            const optionValue = option.uniqueId !== undefined ? option.uniqueId : (option.value || option[dropdownData.value]);
            return String(optionValue) === String(formikValue);
        });

        // We need to return the found option object for MUI Autocomplete to work properly
        return found || null;
    }, [formikValue, options, dropdownData?.value]);

    // Value equality function for Autocomplete - we get a warning if we don't have this from MUI - suggested by MUI
    const isOptionEqualToValue = (option, value) => {
        if (!option) return false;
        if (value === null || value === undefined) return false;

        // Hit uniqueId for comparison first
        const optionValue = option.uniqueId !== undefined ? option.uniqueId : (option.value || option[dropdownData?.value]);

        let compareValue;
        if (typeof value === 'object' && value !== null) {
            compareValue = value.uniqueId !== undefined ? value.uniqueId : (value.value || value[dropdownData?.value]);
        } else {
            compareValue = value;
        }

        return String(optionValue) === String(compareValue);
    };

    const handleChange = (event, newValue) => {
        const selectedValue = newValue ?
            (newValue.uniqueId !== undefined ? newValue.uniqueId : (newValue.value || newValue[dropdownData?.value])) :
            getEmptyValue();

        const syntheticEvent = {
            target: {
                name: labelId,
                value: selectedValue
            }
        };

        formikChange(syntheticEvent, selectedValue);
    };

    const getOptionLabel = (option) => {
        if (!option) return '';
        return option.label || option.displayText || option[dropdownData?.key] || '';
    };

    // HTML-based highlighting for the letters in the dropdown
    const highlightText = (text, searchText) => {
        if (!searchText || !text) return text;

        // Escape HTML special characters in the original text
        const escapeHtml = (str) => {
            return str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const escapedText = escapeHtml(text);
        const escapedSearch = escapeHtml(searchText);

        // case-insensitive replacement
        const regex = new RegExp(`(${escapedSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

        return escapedText.replace(regex, '<span style="color: #2196f3; font-weight: bold;">$1</span>');
    };

    const endAdornmentItems = [];

    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled} className={isDoubled ? 'doubled' : ''}>
            <InputLabel htmlFor={labelId}>
                {label}
                <span className={mandatory ? 'asterisk' : ''}>
                    {mandatory ? '*' : ''}
                </span>
            </InputLabel>

            <Tooltip title={onTooltip ? onTooltip : ""} arrow>
                <Autocomplete
                    id={labelId}
                    options={options}
                    value={selectedOption}
                    onChange={handleChange}
                    autoHighlight={true}
                    disableClearable={disableClearable}
                    classes={{
                        root: isFocused ? 'Mui-focused' : ''
                    }}
                    PopperComponent={(props) => ( //Fix z-index issue with the top nav..
                        <Popper
                            {...props}
                            style={{
                                ...props.style,
                                zIndex: 1050
                            }}
                        />
                    )}
                    sx={{
                        '& input:not(:focus)': {
                            cursor: 'pointer',
                        },
                        '& input:focus': {
                            cursor: 'text',
                        },
                        '& .MuiAutocomplete-endAdornment': {
                            cursor: 'pointer !important',
                            right: '0px !important',
                        },
                        '& .MuiOutlinedInput-root:not(.Mui-focused)': {
                            cursor: 'pointer',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused': {
                            cursor: 'text',
                        }
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                        setInputValue(newInputValue);

                        // When input is cleared, set appropriate empty value
                        if (reason === 'clear' || (reason === 'input' && newInputValue === '')) {
                            const emptyValue = getEmptyValue();
                            const syntheticEvent = {
                                target: {
                                    name: labelId,
                                    value: emptyValue
                                }
                            };
                            formikChange(syntheticEvent, emptyValue);
                        }
                    }}
                    onOpen={() => {
                        setIsFocused(true);
                    }}
                    onClose={() => {
                        setIsFocused(false);
                    }}
                    disabled={disabled}
                    loading={loading}
                    loadingText="Loading..."
                    noOptionsText={loading ? "Loading..." : (noOptionsText || t('No options'))}
                    fullWidth={true}
                    openOnFocus={true}
                    getOptionLabel={getOptionLabel}
                    isOptionEqualToValue={isOptionEqualToValue}
                    renderOption={(props, option) => {
                        const displayText = option.label || option.displayText || '';

                        // Only highlight when user is actively typing (not when showing selected option - looks kind of wierd if so)
                        const selectedOptionText = selectedOption ? getOptionLabel(selectedOption) : '';
                        const isUserTyping = inputValue && inputValue !== selectedOptionText;

                        const highlightedText = displayText && isUserTyping ? highlightText(displayText, inputValue) : displayText;

                        return (
                            <li {...props} key={option.value || option.uniqueId} style={{ minHeight: '40px', display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
                                {displayText ? (
                                    isUserTyping ? (
                                        <span dangerouslySetInnerHTML={{ __html: highlightedText }} />
                                    ) : (
                                        <span>{highlightedText}</span>
                                    )
                                ) : (
                                    <span style={{ color: '#999', fontStyle: 'italic' }}>{`Select a ${label}`}</span>
                                )}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            inputRef={inputRef}
                            name={labelId}
                            variant="outlined"
                            placeholder={loading ? "Loading..." : placeholder}
                            error={errors && touched}
                            onFocus={() => {
                                setIsFocused(true);
                            }}
                            onBlur={() => {
                                // Don't immediately hide on blur - let onClose handle it
                                // This prevents flicker when clicking clear button
                            }}
                            inputProps={{
                                ...params.inputProps,
                                "aria-label": label,
                                "aria-required": mandatory ? "true" : null
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {endAdornmentItems}
                                        {params.InputProps.endAdornment}
                                    </>
                                )
                            }}
                        />
                    )}
                />
            </Tooltip>

            {errors && touched && (
                <FormHelperText className="helperText">{errors}</FormHelperText>
            )}
        </FormInputWrapper>
    );
};

/**
 * MultiSelectAutoInput - Enhanced multiselect dropdown with search and autocomplete
 * @param {{
 * label: string,
 * labelId: string,
 * formik?: Object,
 * formikValue?: any[],
 * formikChange?: Function,
 * isDoubled?: Boolean,
 * disabled?: boolean,
 * errors?: formik.errors.labelId,
 * touched?: formik.touched.labelId,
 * mandatory?: Boolean,
 * DropdownData: Array<{uniqueId, displayText, ...}>,
 * customStyle?: object,
 * sortAsc?: boolean,
 * onTooltip?: string,
 * placeholder?: string,
 * loading?: boolean,
 * noOptionsText?: string,
 * maxSelections?: number,
 * onCustomChange?: Function,
 * limitTags?: number,
 * }} props
 */
export const MultiSelectAutoInput = (props) => {
    const { t } = useTranslation();
    const {
        label,
        labelId,
        formik,
        formikValue,
        formikChange,
        isDoubled = false,
        disabled = false,
        errors,
        touched,
        mandatory = false,
        DropdownData,
        customStyle = {},
        sortAsc = false,
        onTooltip,
        placeholder,
        loading = false,
        noOptionsText,
        maxSelections,
        onCustomChange,
        limitTags = 3,
    } = props;

    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    // Process dropdown data to create options array
    const processedOptions = useMemo(() => {
        if (!DropdownData || !Array.isArray(DropdownData)) {
            return [];
        }

        const rawOptions = DropdownData
            .filter((item) => !(item.displayText === "" && (item.uniqueId === 0 || item.uniqueId === "")))
            .map((item) => ({
                value: item.uniqueId,
                label: item.displayText,
                uniqueId: item.uniqueId,
                displayText: item.displayText,
                ...item
            }));

        // Sort if sortAsc is true
        if (sortAsc && rawOptions.length > 0) {
            rawOptions.sort((a, b) => {
                const labelA = a.label || '';
                const labelB = b.label || '';
                return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
            });
        }

        // Adding a non-selectable placeholder option "Select [label]" as the first option with pluralization
        // since this is a multiselect dropdown
        const pluralizedLabel = label && !label.toLowerCase().endsWith('s') && !label.toLowerCase().endsWith('(s)') ? `${label}(s)` : label;
        const selectAllOption = {
            value: '',
            label: `Select ${pluralizedLabel}`,
            uniqueId: '',
            displayText: `Select ${pluralizedLabel}`,
            isPlaceholder: true
        };

        return [selectAllOption, ...rawOptions];
    }, [DropdownData, sortAsc, label]);

    useEffect(() => {
        setOptions(processedOptions);
    }, [processedOptions]);

    // Get current value from formik or direct prop and convert to option objects
    const rawCurrentValue = formik ? formik.values[labelId] : formikValue;
    const currentValue = useMemo(() => {
        if (!rawCurrentValue || !Array.isArray(rawCurrentValue) || rawCurrentValue.length === 0) {
            return [];
        }

        return rawCurrentValue
            .map(selectedId => {
                return options.find(option =>
                    String(option.uniqueId) === String(selectedId) ||
                    String(option.value) === String(selectedId)
                );
            })
            .filter(option => option != null);
    }, [rawCurrentValue, options]);

    // let MUI handle most of the matching but we need to do this check. It also eliminates the warning.
    const isOptionEqualToValue = (option, value) => {
        if (!option || !value) return false;

        if (typeof value === 'string' || typeof value === 'number') {
            return String(option.uniqueId) === String(value) || String(option.value) === String(value);
        }

        return String(option.uniqueId) === String(value.uniqueId) || String(option.value) === String(value.value);
    };

    const handleChange = (event, newValues) => {
        if (maxSelections && newValues.length > maxSelections) {
            return;
        }

        const selectedValues = newValues
            .filter(item => item != null)
            .map(item =>
                item.uniqueId !== undefined ? item.uniqueId : item.value
            );

        if (formik) {
            // Use formik pattern - this is preferred for all you devs out there reading this ;-D
            formik.setFieldValue(labelId, selectedValues);
            onCustomChange && onCustomChange(event, newValues);
        } else if (formikChange) {
            // Use direct change handler
            const syntheticEvent = {
                target: {
                    name: labelId,
                    value: selectedValues
                }
            };
            formikChange(syntheticEvent, selectedValues);
        }
    };

    const getOptionLabel = (option) => {
        if (!option) return '';

        if (option.isPlaceholder) {
            return option.label || option.displayText || '';
        }

        // Handle case where option is just a value (for defaultValue matching)
        if (typeof option === 'string' || typeof option === 'number') {
            const found = options.find(opt =>
                String(opt.uniqueId) === String(option) || String(opt.value) === String(option)
            );
            return found ? (found.label || found.displayText || '') : String(option);
        }

        // Handle case where option is an object
        return option.label || option.displayText || '';
    };

    const highlightText = (text, searchText) => {
        if (!searchText || !text) return text;

        const escapeHtml = (str) => {
            return str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const escapedText = escapeHtml(text);
        const escapedSearch = escapeHtml(searchText);

        const regex = new RegExp(`(${escapedSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');

        return escapedText.replace(regex, '<span style="color: #2196f3; font-weight: bold;">$1</span>');
    };

    const enhancedOptions = options;

    return (
        <FormInputWrapper style={customStyle} isDoubled={isDoubled} className={isDoubled ? 'doubled' : ''}>
            <InputLabel htmlFor={labelId}>
                {label}
                <span className={mandatory ? 'asterisk' : ''}>
                    {mandatory ? '*' : ''}
                </span>
            </InputLabel>

            <Tooltip title={onTooltip ? onTooltip : ""} arrow>
                <Autocomplete
                    multiple
                    id={labelId}
                    options={enhancedOptions}
                    value={currentValue}
                    onChange={handleChange}
                    disableClearable={false}
                    limitTags={limitTags}
                    disableCloseOnSelect
                    openOnFocus
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    sx={{
                        '& input:not(:focus)': {
                            cursor: 'pointer',
                        },
                        '& input:focus': {
                            cursor: 'text',
                        },
                        '& .MuiAutocomplete-endAdornment': {
                            cursor: 'pointer !important',
                            right: '0px !important',
                        },
                        '& .MuiOutlinedInput-root:not(.Mui-focused)': {
                            cursor: 'pointer',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused': {
                            cursor: 'text',
                        }
                    }}
                    disabled={disabled}
                    loading={loading}
                    loadingText="Loading..."
                    noOptionsText={loading ? "Loading..." : (noOptionsText || t('No options'))}
                    fullWidth={true}
                    getOptionLabel={getOptionLabel}
                    isOptionEqualToValue={isOptionEqualToValue}
                    autoHighlight={true}
                    renderOption={(props, option, { selected }) => {
                        const displayText = option.label || option.displayText || '';

                        // non-selectable placeholder option
                        if (option.isPlaceholder) {
                            return (
                                <li
                                    key="placeholder"
                                    style={{
                                        minHeight: '20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px 16px',
                                        color: '#999',
                                        fontStyle: 'italic',
                                        pointerEvents: 'none',
                                        cursor: 'default'
                                    }}
                                >
                                    <span>{displayText}</span>
                                </li>
                            );
                        }

                        const highlightedText = displayText && inputValue ? highlightText(displayText, inputValue) : displayText;

                        return (
                            <li {...props} key={option.value || option.uniqueId} style={{ minHeight: '40px', display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
                                {displayText && (
                                    inputValue ? (
                                        <span dangerouslySetInnerHTML={{ __html: highlightedText }} />
                                    ) : (
                                        <span>{highlightedText}</span>
                                    )
                                )}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            inputRef={inputRef}
                            name={labelId}
                            variant="outlined"
                            placeholder={loading ? "Loading..." : placeholder}
                            error={errors && touched ? true : false}
                            disabled={disabled}
                        />
                    )}
                />
            </Tooltip>

            {errors && touched && (
                <FormHelperText className="helperText">{errors}</FormHelperText>
            )}
        </FormInputWrapper>
    );
};